module.exports = __webpack_public_path__ + "static/media/ethereum.c5bd7c4f.png";